import { useNavigate, useLocation } from "react-router-dom";
import { XCircle, Clock, ArrowRight, RefreshCw } from "lucide-react";

export default function PaymentFailed() {
  const navigate = useNavigate();
  const location = useLocation();
  const isTimeout = location.state?.reason === "timeout";
  const merchantOrderId = location.state?.merchantOrderId;

  return (
    <div style={{
      minHeight: "100vh", background: "#0F172A",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, sans-serif", padding: 24,
    }}>
      <div style={{
        width: "100%", maxWidth: 420,
        background: "#1E293B",
        border: "1px solid rgba(255,255,255,0.07)",
        borderRadius: 20,
        padding: "40px 32px",
        textAlign: "center",
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: "50%",
          background: isTimeout ? "rgba(234,179,8,0.1)" : "rgba(239,68,68,0.1)",
          border: `2px solid ${isTimeout ? "rgba(234,179,8,0.25)" : "rgba(239,68,68,0.25)"}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 24px",
        }}>
          {isTimeout
            ? <Clock size={36} color="#EAB308" />
            : <XCircle size={36} color="#EF4444" />}
        </div>

        <div style={{ fontSize: 22, fontWeight: 800, color: "#F1F5F9", marginBottom: 8, letterSpacing: "-0.3px" }}>
          {isTimeout ? "Payment Pending" : "Payment Failed"}
        </div>
        <div style={{ fontSize: 14, color: "#64748B", lineHeight: 1.7, marginBottom: isTimeout ? 12 : 28 }}>
          {isTimeout
            ? "We couldn't confirm this in the app yet, but if money was deducted, your API calls will be added automatically within a few minutes — no need to pay again or take any action."
            : "Your payment was not completed. No money has been deducted from your account."}
        </div>

        {isTimeout && merchantOrderId && (
          <div style={{
            fontSize: 12, color: "#94A3B8", background: "#0F172A",
            border: "1px solid rgba(255,255,255,0.07)", borderRadius: 8,
            padding: "8px 12px", marginBottom: 28, wordBreak: "break-all",
          }}>
            Order ID: <span style={{ color: "#e0e7ff", fontWeight: 600 }}>{merchantOrderId}</span>
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {isTimeout ? (
            <button
              onClick={() => navigate("/app", { replace: true })}
              style={{
                width: "100%", height: 44, borderRadius: 10,
                background: "#6366F1", border: "none",
                color: "#fff", fontSize: 14, fontWeight: 700,
                cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                boxShadow: "0 2px 12px rgba(99,102,241,0.3)",
              }}
            >
              Back to Dashboard <ArrowRight size={14} />
            </button>
          ) : (
            <>
              <button
                onClick={() => navigate("/app", { replace: true })}
                style={{
                  width: "100%", height: 44, borderRadius: 10,
                  background: "#6366F1", border: "none",
                  color: "#fff", fontSize: 14, fontWeight: 700,
                  cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                  boxShadow: "0 2px 12px rgba(99,102,241,0.3)",
                }}
              >
                <RefreshCw size={14} /> Try Again
              </button>

              <button
                onClick={() => navigate("/app", { replace: true })}
                style={{
                  width: "100%", height: 44, borderRadius: 10,
                  background: "transparent",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#64748B", fontSize: 14, fontWeight: 600,
                  cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                }}
              >
                Back to App <ArrowRight size={14} />
              </button>
            </>
          )}
        </div>

        <div style={{ marginTop: 24, fontSize: 12, color: "#475569" }}>
          Need help?{" "}
          <a
            href={`mailto:support@lorrykhojo.com${merchantOrderId ? `?subject=Payment%20query%20-%20${merchantOrderId}` : ""}`}
            style={{ color: "#6366F1", textDecoration: "none" }}
          >
            support@lorrykhojo.com
          </a>
        </div>
      </div>
    </div>
  );
}
